import React, { useEffect } from 'react'
import { AdvertisingWindow, LoginLayout } from '@workwave-tidal/core/login-ui'
import Stack from '@mui/material/Stack'
import { Footer } from '@user/components/Login/LoginSSO/Footer'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUserAuthenticated } from '@user/store/authorization/userSlice'
import { LoginSSOContent } from '@user/components/Login/LoginSSO/LoginSSOContent'

export const LoginSSO = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const authenticated = useSelector(selectUserAuthenticated)

  useEffect(() => {
    if (authenticated && location.pathname !== '/scdashboard') {
      navigate('/scdashboard')
    }
  }, [authenticated, navigate, location.pathname])

  if (authenticated) return null

  return (
    <Stack width="100%" height="100vh" sx={{ backgroundColor: '#f9fafb' }}>
      <LoginLayout
        maxHeaderHeight={70}
        main={<LoginSSOContent />}
        secondary={
          <AdvertisingWindow
            product={'WWM'}
            url="https://ww-login.netlify.app/pestpac?pathname=/&hash=&ctx=360"
            language="en"
            loadingErrorText="Something happened. Impossible to load content!"
          />
        }
        mainFooter={<Footer />}
      />
    </Stack>
  )
}
